import { useState } from 'react'
import { DEFAULT_PER_PAGE } from 'apps/carrier/constants/carrierProfile'

export type SortFieldType = 'name'
export type SortOrderType = 'asc' | 'desc'

export interface IFacilityFilters {
  // search by facility name, address or contact information
  nameAddressOrContact?: string
}

export interface IUseFacilityParamsState {
  sortField?: SortFieldType
  sortOrder?: SortOrderType
  pageNumber: number
  pageSize: number
  filters?: IFacilityFilters
}

/**
 * Hook used to manage getFacility params
 */
export const useFacilityParams = (
  defaults: IUseFacilityParamsState = {
    sortField: 'name',
    sortOrder: 'asc',
    pageNumber: 1,
    pageSize: DEFAULT_PER_PAGE,
  }
) => {
  const [params, setParams] = useState<IUseFacilityParamsState>(defaults)

  return {
    params,
    setParams,
  }
}
